<template>
    <div class="layout">
        <Layout>
            <Header>
                <Menu mode="horizontal" theme="dark"  active-name="1" @on-select="langSwitch">
                    <div class="layout-logo"></div>
                   
                    <div class="logout_box">
                        <Icon type="ios-contact" size="25" />
                        <div class="name">admin</div>
                        <span class="fh">|</span>
                    <span class="logout" @click="logout">{{$t("menu.loginOut")}}</span>
                    </div>
                     <Submenu name="lang" style="float:right">
                          <template slot="title">
                            <Icon type="md-list" />{{$t("menu.lang")}}
                        </template>
                        <MenuItem name="zh">{{$t("menu.zh")}}</MenuItem>
                        <MenuItem name="vn">{{$t("menu.vn")}}</MenuItem>
                        <MenuItem name="en">{{$t("menu.en")}}</MenuItem>
                     </Submenu>
                    
                        <div class="notification" v-if="withdraw_count > 0" @click="handleWithdrawClick"> 
                           <span>提现</span> <span class="count">{{withdraw_count}}</span>
                        </div>
                   
                  
                        <div class="notification" v-if="recharge_count > 0" @click="handleRechargeClick"> 
                            <span>充值</span> <span class="count">{{recharge_count}}</span>
                        </div>
                   
                </Menu>
            </Header>
            <Layout>
                <Sider hide-trigger :style="{ height: '100vh'}">
                    <Menu
                        :active-name="active_nav"
                        theme="dark"
                        width="220"
                        :style="{height: '100vh', background: '#000'}"
                        @on-select="select_nav"
                        
                        :open-names="['5','6','7']"
                    >
                        <MenuItem name="1-1" to="home">
                            <Icon type="md-home" />
                            <span>{{$t('menu.index')}}</span>
                        </MenuItem>
                        <Submenu name="2">
                            <template slot="title">
                                <Icon type="md-settings" />{{$t('menu.systemSetting')}}
                            </template>
                            <MenuItem name="2-1" to="convention">{{$t('menu.conventionSetting')}}</MenuItem>
                            <MenuItem name="2-2" to="loan">{{$t('menu.loanSetting')}}</MenuItem>
                            <MenuItem name="2-3" to="message">{{$t('menu.smsSetting')}}</MenuItem>
                            <MenuItem name="2-4" to="gathering">{{$t('menu.payeeSetting')}}</MenuItem>
                            <MenuItem name="2-5" to="agreement">{{$t('menu.protocolSetting')}}</MenuItem>
                        </Submenu>
                        <MenuItem name="3-1" to="admin">
                            <Icon type="md-person" />
                            <span>{{$t('menu.siteAdminSetting')}}</span>
                        </MenuItem>
                        <!-- <MenuItem name="3-1" to="order_text_tip">
                            <Icon type="ios-list-box" />
                            <span>{{$t('menu.orderTextSetting')}}</span>
                        </MenuItem> -->
                        <!-- <MenuItem name="4-1">
                            <Icon type="md-list-box" />
                            <span>文章列表</span>
                        </MenuItem>-->
                        <Submenu name="4">
                            <template slot="title">
                                <Icon type="md-people" />{{$t('menu.agentList')}}
                            </template>
                            <MenuItem name="4-1" to="agent">
                                <Icon type="ios-people" />
                                <span>{{$t('menu.agentList')}}</span>
                            </MenuItem>
                            <MenuItem name="4-2" to="invite">
                                <Icon type="ios-people" />
                                <span>{{$t('menu.inviteCode')}}</span>
                            </MenuItem>
                            <MenuItem name="4-3" to="kefu">
                            <Icon type="ios-people" />
                            <span>{{$t('agent.phoneKefu')}}</span>
                        </MenuItem>
                        </Submenu>
                       
                       <Submenu name="5">
                         <template slot="title">
                            <Icon type="md-people" />{{$t('menu.userManage')}}
                         </template>
                         <MenuItem name="5-1" to="user">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.userList')}}</span>
                         </MenuItem>
                         <!-- <MenuItem name="5-2" to="wallet_kyc">
                            <Icon type="ios-cash" />
                            <span>{{$t('walletKyc')}}</span>
                         </MenuItem> -->
                         <MenuItem name="5-2" to="crypto_recharge">
                            <Icon type="logo-bitcoin" />
                            <!-- <span>{{$t('menu.cryptoRecharge')}}</span> -->
                             <span>充值</span>
                        </MenuItem>
                         <!-- <MenuItem name="5-3" to="blind_boxes">
                            <Icon type="ios-list-box" />
                            <span>{{$t('menu.blind_boxes')}}</span>
                         </MenuItem> -->
                         <MenuItem name="5-3" to="bank_withdraw">
                            <Icon type="md-cash" />
                            <!-- <span>{{$t('menu.bankWithdraw')}}</span> -->
                            <span>提现</span>
                        </MenuItem>
                         
                       </Submenu>
                       
                        <MenuItem name="6-1" to="cp_order">
                            <Icon type="ios-list-box" />
                            <span>{{$t('menu.order')}}</span>
                        </MenuItem>
                      
                       
                        <MenuItem name="7-1" to="product_manage">
                            <Icon type="md-list" />
                            <span>产品管理</span>
                        </MenuItem>
                       
                    <!-- <Submenu name="6">
                        <template slot="title">
                            <Icon type="logo-bitcoin" />{{$t('menu.crypto')}}
                        </template>
                        <MenuItem name="6-1" to="crypto_detail">
                            <Icon type="logo-bitcoin" />
                            <span>{{$t('menu.cryptoDetail')}}</span>
                        </MenuItem>
                        <MenuItem name="6-2" to="crypto_recharge">
                            <Icon type="logo-bitcoin" />
                            <span>{{$t('menu.cryptoRecharge')}}</span>
                        </MenuItem>
                        <MenuItem name="6-3" to="order">
                            <Icon type="ios-list-box" />
                            <span>{{$t('menu.order')}}</span>
                         </MenuItem>
                    </Submenu> -->
                    <!-- <Submenu name="7">
                        <template slot="title">
                            <Icon type="logo-bitcoin" />{{$t('menu.bank')}}
                        </template>
                        <MenuItem name="7-1" to="bank_detail">
                            <Icon type="logo-bank" />
                            <span>{{$t('menu.bankDetail')}}</span>
                        </MenuItem>
                        <MenuItem name="7-2" to="bank_withdraw">
                            <Icon type="logo-bank" />
                            <span>{{$t('menu.bankWithdraw')}}</span>
                        </MenuItem>
                    </Submenu> -->
                        <!-- <MenuItem name="6-1" to="borrow">
                            <Icon type="md-list" />
                            <span>{{$t('menu.borrowList')}}</span>
                        </MenuItem> -->
                        
                        <!-- <MenuItem name="8-1" to="redfile">
                            <Icon type="md-person" />
                            <span>{{$t('redfile')}}</span>
                        </MenuItem> -->
                    </Menu>
                </Sider>
                <Layout :style="{padding: '24px',}">
                    <!-- <Breadcrumb :style="{margin: '24px 0'}">
                        <BreadcrumbItem>Home</BreadcrumbItem>
                        <BreadcrumbItem>Components</BreadcrumbItem>
                        <BreadcrumbItem>Layout</BreadcrumbItem>
                    </Breadcrumb>-->
                    <Content
                        :style="{padding: '24px', height: content_h, overflowY: 'scroll'}"
                    >
                        <transition :name="transitionName">
                            <router-view />
                        </transition>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template>
<script>
    import withdrawVoice from '../../static/audio/withdraw_voice.mp3';
    import rechargeVoice from '../../static/audio/recharge_voice.mp3';
export default {
    data() {
        return {
            content_h: 0,
            transitionName: "slide-right",
            active_nav: sessionStorage.getItem("active_nav") || "1-1",
            lang:"zh",
            withdraw_count: 0,
            recharge_count: 0,
            notificationPlayCount: 0, // 记录声音播放次数
        };
    },
    mounted() {
        this.content_h = document.documentElement.clientHeight - 115 + "px";
        setInterval(() => {
            this.getNotificationCount();
        }, 30000);
    },
    methods: {
        select_nav(name) {
            sessionStorage.setItem("active_nav", name);
        },
        langSwitch(name){
            console.log(name);
            window.localStorage.setItem('localeLanguage',name)
            document.cookie = 'locale='+name;
            //Vue.config.lang = name
            this.$i18n.locale = name
            //this.$i18n.setup(name);
        },
        logout() {
            this.$Modal.confirm({
                title: this.$i18n.t("menu.loginOutTitle"),
                content: "<p>"+this.$i18n.t("menu.loginOutContent")+"</p>",
                onOk: () => {
                    this.$post(this.$path.logout).then(res => {
                        if (res.success) {
                            this.$router.push({ name: "login" });
                        }
                    });
                }
            });
        },
        getNotificationCount() {
            this.$get(this.$path.tip).then(res => {
                if (res.success) {
                    this.withdraw_count = res.data.withdrawCount;
                    this.recharge_count = res.data.chargeCount; 
                    // 如果没有通知，重置计数器
                    if ((!res.data.withdrawCount || res.data.withdrawCount === 0) && 
                        (!res.data.chargeCount || res.data.chargeCount === 0)) {
                        this.notificationPlayCount = 0;
                        return;
                    }
                    
                    // 最多提示5次
                    if (this.notificationPlayCount >= 5) {
                        return;
                    }
                    
                    // this.notification_count = res.data;
                    // if (this.notification_count > 0) {
                    //     new Audio(withdrawVoice).play();
                    //     this.$Message.success("您有新的提现消息，请点击查看");
                    // }
                    if(res.data.withdrawCount > 0 || res.data.chargeCount > 0) {
                        this.notificationPlayCount++;
                        new Audio(withdrawVoice).play();
                        setTimeout(() => {
                            new Audio(rechargeVoice).play();
                        }, 6000);
                    }
                    else if (res.data.withdrawCount > 0) {
                        this.notificationPlayCount++;
                        new Audio(withdrawVoice).play();
                    }
                    else if (res.data.chargeCount > 0) {
                        this.notificationPlayCount++;
                        new Audio(rechargeVoice).play();
                        // this.$Message.success("您有新的充值消息，请点击查看");
                    }
                }
            });
        },
        handleWithdrawClick() {
            this.$router.push({ name: "bank_withdraw" });
        },
        handleRechargeClick() {
            this.$router.push({ name: "crypto_recharge" });
        }
    }
};
</script>
<style lang="scss" scoped>
.layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.ivu-layout-header {
    padding-left: 0;
    height: 60px;
    line-height: 60px;
}
.layout-logo {
    width: 200px;
    height: 60px;
    line-height: 60px;
    float: left;
    padding-left: 15px;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    font-family: cursive;
}
.layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}
.ivu-layout-header {
    padding-right: 15px;
}
.logout_box {
    float: right;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
        margin-left: 5px;
    }
    .fh {
        margin: 0 10px;
    }
    .logout {
        font-size: 13px;
        cursor: pointer;
    }
}
.notification {
    float: right;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    font-size: 13px;
    &::after {
        content: '|';
        margin: 0 10px;
    }
    .count {
        margin-left: 5px;
        width: 20px;
        height: 20px;
        background: rgb(247, 125, 125);
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        color: #ffffff;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/view.vue